export default "__VITE_ASSET__cf94748e__"